// extracted by mini-css-extract-plugin
export default {"wrapper":"AdsPage_wrapper__BFlT1","header":"AdsPage_header__j1wRA","titleRow":"AdsPage_titleRow__nPgsT","title":"AdsPage_title__gOI8Y"};